import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=48061b3c&scoped=true&"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=48061b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48061b3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48061b3c')) {
      api.createRecord('48061b3c', component.options)
    } else {
      api.reload('48061b3c', component.options)
    }
    module.hot.accept("./LoadingSpinner.vue?vue&type=template&id=48061b3c&scoped=true&", function () {
      api.rerender('48061b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UIComponents/LoadingSpinner.vue"
export default component.exports